type StringifiableValue =
  | string
  | number
  | readonly string[]
  | null
  | undefined;

export const toStringOrEmpty = (value: StringifiableValue): string =>
  value?.toString() ?? '';
